import React from "react";
import BasicInformationForm from "../../../../components/forms/BasicInformationForm/Index";
import ContactInformationForm from "../../../../components/forms/ContactInformationForm/Index";
import LocationForm from "../../../../components/forms/LocationForm/Index";

export default function CombinedInformationSection({
  values,
  errors,
  touched,
  handleChange,
  setFieldValue,
  stateRef,
  nameCheckStatus,
  onNameChange,
  userData,
}) {
  return (
    <div className="combined-info-section">
      <BasicInformationForm
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
        setFieldValue={setFieldValue}
        nameCheckStatus={nameCheckStatus}
        onNameChange={onNameChange}
        isEditMode={userData?.setupCompleted ? !!values.shopName : false}
      />

      <ContactInformationForm
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
      />

      <LocationForm
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
        setFieldValue={setFieldValue}
        stateRef={stateRef}
      />
    </div>
  );
}
